<!--
 * @Author: Latte
 * @Date: 2021-08-27 12:03:41
 * @LAstEditors: Latte
 * @LastEditTime: 2021-09-07 16:16:16
 * @FilePath: \Siui.Cloud.Medical.Web\src\views\mai\liveMgt\liveList\member\index.vue
-->
<template>
	<div>
		<div class="topbar">

			<div>
				<el-input v-model="searchValue" size="mini" prefix-icon="el-icon-search" style="width: 400px"
					@keyup.enter.native="search()" />

				<el-button :disabled="!searchValue" type="primary" size="mini" icon="el-icon-search"
					style="margin-left: 10px" @click="search()">
					搜索
				</el-button>

				<br />
				<!-- 禁言列表没有筛选项 -->
				<div v-if="forbiddenStatus === 0" style="padding-top: 20px;">
					<!-- <el-select clearable v-model="curOnlineState" @change="curOnlineStateChange">
						<el-option :value="true" label="在线"></el-option>
						<el-option :value="false" label="离线"></el-option>
					</el-select> -->
					<el-select clearable v-model="curUserRole" @change="curUserRoleChange">
						<el-option v-for="item in userRoleOptions" :key="item" :value="item"
							:label="item | liveUserRoleTransform"></el-option>
					</el-select>

          <el-select v-if="showAudienceRole()" clearable v-model="curSystemRoleOption" @change="curSystemRoleChange" style="padding-left: 20px">
            <el-option v-for="item in systemRoleOptions" :key="item.roleID" :value="item.roleID"
                       :label="item.roleName"></el-option>
          </el-select>
				</div>

			</div>

			<div>
				<el-button :disabled="pageOpt.totalCount <= 0" type="success" size="mini" icon="el-icon-download"
					style="margin-left: 10px" @click="exportToExcel">
					导出excel
				</el-button>
			</div>
		</div>

		<!-- 用户列表 -->
		<div v-if="forbiddenStatus === 0 ">
			<el-table v-loading="loading" :data="tableData" border stripe class="data-table"
				:header-cell-style="{ background: '#F5F7FA' }">

				<el-table-column label="用户ID" prop="userID" width="100" align="center" />

				<el-table-column label="用户名" width="150" align="center">
					<template slot-scope="scope">
						{{ scope.row.firstName + scope.row.lastName }}
					</template>
				</el-table-column>

				<el-table-column label="昵称" prop="nickname" width="150" align="center" />

				<el-table-column label="直播角色" width="100" align="center">
					<template slot-scope="scope">
						{{
							            scope.row.userRole | liveUserRoleTransform
							          }}
					</template>
				</el-table-column>

        <el-table-column v-if="showAudienceRole()" label="用户角色" width="100" align="center">
          <template slot-scope="scope">
            <el-tag v-for="item in scope.row.roleList" :key="item.roleID" >{{item.roleName}}</el-tag>
          </template>
        </el-table-column>

				<el-table-column label="手机号" width="150" align="center">
					<template slot-scope="scope">
						{{ scope.row.mobilePhone }}
					</template>
				</el-table-column>

				<el-table-column label="单位" width="150" align="center" show-overflow-tooltip>
					<template slot-scope="scope">
						{{ scope.row.organization }}
					</template>
				</el-table-column>

				<el-table-column label="IP" width="150" align="center">
					<template slot-scope="scope">
						{{ scope.row.ip }}
					</template>
				</el-table-column>

				<el-table-column label="IP归属地" width="150" align="center">
					<template slot-scope="scope">
						{{ scope.row.province }}
					</template>
				</el-table-column>

				<el-table-column label="观看时长(min)" width="150" align="center">
					<template slot-scope="scope">
						{{ scope.row.watchTimeLength | formatSecond2Min }}
					</template>
				</el-table-column>

				<el-table-column label="加入时间" align="center">
					<template slot-scope="scope">
						{{ scope.row.joinTime | formatDateTime }}
					</template>
				</el-table-column>

				<el-table-column label="最后在线时间" align="center">
					<template slot-scope="scope">
						{{ scope.row.lastOnlineTime | formatDateTime }}
					</template>
				</el-table-column>

				<el-table-column label="在线状态" width="150" align="center">
					<template slot-scope="scope">
						{{ scope.row.isOnline ? '是' : '否' }}
					</template>
				</el-table-column>
			</el-table>
		</div>

		<!-- 禁言列表 -->
		<div v-else>
			<el-table v-loading="loading" :data="tableData" border stripe class="data-table"
				:header-cell-style="{ background: '#F5F7FA' }">

				<el-table-column label="用户ID" prop="userID" width="200" align="center" />

				<el-table-column label="用户名" width="200" align="center">
					<template slot-scope="scope">
						{{ scope.row.firstName + scope.row.lastName }}
					</template>
				</el-table-column>

				<el-table-column label="昵称" prop="nickname" width="200" align="center" />

				<el-table-column label="加入时间" prop="joinTime" align="center">
					<template slot-scope="scope">
						{{ scope.row.joinTime | formatDateTime }}
					</template>
				</el-table-column>

				<el-table-column label="最后在线时间" prop="lastOnlineTime" align="center">
					<template slot-scope="scope">
						{{ scope.row.lastOnlineTime | formatDateTime }}
					</template>
				</el-table-column>

				<el-table-column label="禁言时间" align="center">
					<template slot-scope="scope">
						{{ scope.row.shutTime | formatDateTime }}
					</template>
				</el-table-column>

				<el-table-column label="操作" width="200" align="center">
					<template slot-scope="scope">
						<el-button disabled size="mini" type="danger" @click="removeFromBlockList(scope.$index, scope.row)">
							移除
						</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>


		<!-- 分页 -->
		<el-pagination background :total="pageOpt.totalCount" :page-size="pageOpt.pageSize"
			:current-page="pageOpt.currentPage" @current-change="curPageChange" />
	</div>
</template>

<script>
	import {
		handleRes
	} from "@/utils/handleRes";
	import {
		getAllAudienceList,
	} from "@/api/mai/liveManagement/liveManagement";

	import {
		isVaild
	} from "@/utils/validate"

	import {
		export_json_to_excel
	} from "@/vendor/Export2Excel.js"

  import {
    getRoleList,
  } from "@/api/role";

	export default {

		data() {
			return {
				liveID: 0,
				loading: false, // 加载开关
				tableData: [], // 传值给子组件mytable
				// 分页配置
				pageOpt: {
					currentPage: 1,
					pageSize: 10,
					totalCount: 0,
				},
				searchValue: "",
				curOnlineState: "",
        //直播间角色,原先接口字段就叫userRole，跟下面的用户角色不是同一个东西
				userRoleOptions: [0, 1, 2, 3, 4],
				curUserRole: "",
        //用户角色,
        systemRoleOptions:[],
        curSystemRoleOption:""
			};
		},
		mounted() {
			this.getAllAudienceList()
		},
		created() {
			this.liveID = this.$route.query.liveID;
      this.getAllRoleList()
		},
		props: {
			forbiddenStatus: {
				type: Number,
				default: 0
			},
		},
		methods: {
      showAudienceRole(){
        return this.config.SHOW_AUDIENCE_ROLE === 'true'
      },
      getAllRoleList(){
        getRoleList().then((res) => {
          return res.data.totalCount

        }).then((res) => {
          return getRoleList({
            pageSize: res
          })
        }).then((res) => {
          this.systemRoleOptions = res.data.result.map((e) => {
            return {
              roleID: e.roleID,
              roleName: e.roleName,
            };
          });
        });
      },
			search() {
				this.pageOpt.currentPage = 1
				this.getAllAudienceList()
			},
			curPageChange(curPage) {
				this.pageOpt.currentPage = curPage
				this.getAllAudienceList()
			},
			curOnlineStateChange() {
				this.search()
			},
			curUserRoleChange() {
				this.search()
			},
      curSystemRoleChange() {
        this.search()
      },
			/**
			 * 刷新列表
			 */
			refreshCurrentList() {
				this.getAllAudienceList();
			},
			getWhere() {
				let where = []
				if (isVaild(this.curOnlineState)) {
					where.push({
						"field": "isOnline",
						"value": this.curOnlineState,
						"op": "equal"
					})
				}

				if (isVaild(this.curUserRole)) {
					where.push({
						"field": "userRole",
						"value": this.curUserRole,
						"op": "equal"
					})
				}
				return where;
			},
			getAllAudienceList() {
				this.loading = true;
				const liveID = this.liveID;
				const params = {
					forbiddenStatus: this.forbiddenStatus,
					keyWord: this.searchValue,
					liveID: liveID,
					pageIndex: this.pageOpt.currentPage,
					pageSize: this.pageOpt.pageSize,
					sortName: "",
					sortOrder: "",
          roleId : this.curSystemRoleOption
				};

				let where = this.getWhere();

				if (where.length > 0) {
					params.where = where
				}

				getAllAudienceList(params).then((res) => {
					console.log(" ----------------------------");
					console.log("getAllAudienceList , res", res);
					console.log(" ----------------------------");
					this.reserveUsersList = res.data.list;
					this.tableData = this.reserveUsersList;
					this.pageOpt.totalCount = res.data.total;

					this.utils.stopLoading(this);
				});
			},
			getExcelInfo() {
				let tName;
				let tHeader;
				let filterValue;
				switch (this.forbiddenStatus) {
					case 0://用户信息
						tName = '用户信息'
						tHeader = [
							'用户ID',
							'用户名',
							'昵称',
							'直播角色',
              '用户角色',
							'手机号',
							'单位',
							'IP',
							'IP归属地',
							'观看时长(min)',
							'加入时间',
							'最后在线时间',
							'当前是否在线'
						]
						filterValue = [
							'userID',
							'userName',
							'nickname',
							'userRole',
              'roleList',
							'mobilePhone',
							'organization',
							'ip',
							'province',
							'watchTimeLength',
							'joinTime',
							'lastOnlineTime',
							'isOnline'
						]
						break
					case 1://禁言列表
						tName = '禁言列表'
						tHeader = [
							'用户ID',
							'用户名',
							'昵称',
							'加入时间',
							'最后在线时间',
							'禁言时间'
						]
						filterValue = [
							'userID',
							'userName',
							'nickname',
							'joinTime',
							'lastOnlineTime',
							'shutTime'
						]
						break;
				}
				return {
					tName,
					tHeader,
					filterValue
				}
			},
			exportToExcel() {
				let {
					tName,
					tHeader,
					filterValue
				} = this.getExcelInfo()
				this.getAllUserInfo(this.forbiddenStatus, tName, tHeader, filterValue)
			},
			getAllUserInfo(forbiddenStatus, tName, tHeader, filterValue) {
				let param = {
					forbiddenStatus: forbiddenStatus, // 0-普通，1禁言
					liveID: this.liveID,
					pageIndex: 0,
					pageSize: this.pageOpt.totalCount,
					sortName: '',
					sortOrder: '',
          roleId : this.curSystemRoleOption
				}
				let where = this.getWhere();
				if (where.length > 0) {
					param.where = where
				}
				getAllAudienceList(param).then(res => {
					let list = this.formatUserInfoTable(res.data.list)
					let data = this.formatJson(filterValue, list)
					console.log("getAllAudienceList ---- " + data)
					export_json_to_excel({
						header: tHeader,
						data,
						filename: tName,
						autoWidth: true,
						bookType: "xlsx",
					})
					this.utils.stopLoading(this)
				})
			},
			/**
			 * 格式化 JSON
			 *
			 * @param filterValue
			 * @param jsonData
			 */
			formatJson(filterValue, jsonData) {
				return jsonData.map(x => filterValue.map(y => {
					return x[y]
				}))
			},
			/**
			 * 格式化 userInfoTable
			 *
			 * @param list
			 */
			formatUserInfoTable(list) {
				let newList = list.map(item => {
					item.userName = item.firstName + item.lastName
					item.userRole = this.$options.filters["liveUserRoleTransform"](item.userRole)
					// item.watchTimeLength = this.$options.filters["formatSecond"](item.watchTimeLength)
					item.watchTimeLength = this.$options.filters["formatSecond2Min"](item.watchTimeLength)
					item.joinTime = this.$options.filters["formatDateTime"](item.joinTime)
					item.lastOnlineTime = this.$options.filters["formatDateTime"](item.lastOnlineTime)
					item.isOnline = item.isOnline ? '是' : '否'
					item.shutTime = this.$options.filters['formatDateTime'](item.shutTime)
          item.roleList = item.roleList.map((entity )=>{
            return entity.roleName
          }).reduce((pre, cur) => {
            return pre  + " " + cur;
          })
					return item
				})

				return newList
			},
			/**
			 * 从禁言列表中移除
			 */
			removeFromBlockList(index, row) {
				this.$confirm('是否将该用户从禁言列表中移除?', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					})
					.then(res => {
						console.log(row.liveID, row.liveUserID, row.userID)
					})
					.catch(err => {
						console.log(err)
					})
			}
		},
	};
</script>

<style>
</style>
